import React from 'react';
import { observer } from 'mobx-react';
import { TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './HeaderRow.module.scss';
import { GridTableRow } from '../../../../../../shared/components/table-components';
import { SortButtons } from '../../../../../../shared/components/buttons';
import { invoicesStore } from '../../../../../stores/invoicesStore';

const HeaderRow = observer(() => {
  const { filterMethods } = invoicesStore;

  const { handleSort, getIsSortedBy } = filterMethods;

  return (
    <GridTableRow variant="unstyled" className={classes.headerRow}>
      <SortButtons
        fieldName="billingDate"
        onSort={handleSort}
        getIsActive={getIsSortedBy}
      >
        Payment Date
      </SortButtons>
      <div>Status</div>
      <div>Active Сlient Seats</div>
      <div>SaaS Tax</div>
      <TitleWithDescription
        title="Total"
        description="SaaS Tax incl"
        titleFont="body-14-bold"
      />
      <div>Customers</div>
      <div>Invoice</div>
    </GridTableRow>
  );
});

export { HeaderRow };
